import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';

import {PremierCancelation} from './PremierCancelation';

export default connect(
  createStructuredSelector({
    featureFlag: variablesFeatureFlag,
  }),
)(PremierCancelation);
